<template>
  <div>
    <v-app style="position: relative">
      <tk-toolbar
        @searchInputMounted="onSearchInputMounted"
        :topBarLift="topBarLift"
      />

      <tk-drawer/>

      <tk-view/>

      <tk-footer/>

      <!-- Cookie consent works via CookieHub, so this is disabled -->
      <!-- <tk-cookie-consent /> -->

      <tk-toast/>

      <!-- App level dialogs -->
      <login-dialog
        v-model="$app.loginDialog"
        :title.sync="$app.loginTitle"
      />
      <tk-page-dialog v-model="$app.pageDialog.show"/>
      <tk-confirm
        ref="confirm"
        @mounted="setupConfirmDialog"
      />

      <terms-dialog
        :show="showTermsDialog"
        :type="termsType"
        update
        @close="onTermsDialogClose"
      />

      <!-- Search popup that appears after 10s of page load below filter buttons -->
      <tk-search-popup v-if="showSearchPopup"/>

      <!-- Newsletter works via MailChimp, so this is disabled -->
      <!--<newslatter-popup/>-->

      <!--
      <tk-new-artist-delivery-terms-popup
        :show="showNewArtistDeliveryTermsPopup"
        @close="showNewArtistDeliveryTermsPopup = false"
      />
      -->

    </v-app>
  </div>
</template>

<script>
import { ROUTE_QUERY } from '@/AppKeys'
import { LocaleUtils } from '@/utils/LocaleUtils'
import { RouteQuery } from '@/services/RouteQuery'
import { ErrorHandler } from '@/utils/ErrorHandler'
import TermsDialog from '@/components/terms/TermsDialog.vue'
import TkToolbar from '@/components/core/TkToolbar'
import TkView from '@/components/core/TkView'
import TkDrawer from '@/components/core/TkDrawer'
import TkFooter from '@/components/core/TkFooter'
import TkPageDialog from '@/components/core/TkPageDialog'
import TkConfirm from '@/components/core/TkConfirm'
import TkToast from '@/components/core/TkToast'
import TkSearchPopup from '@/components/core/TkSearchPopup'
import LoginDialog from '@/components/login/LoginDialog'
// import TkCookieConsent from "@/components/core/TkCookieConsent";
// import NewslatterPopup from '@/components/Domain/Newsletter/NewslatterPopup.vue'
// import TkNewArtistDeliveryTermsPopup from "@/components/core/TkNewArtistDeliveryTermsPopup.vue";

const localeUtils = new LocaleUtils();
const handler = new ErrorHandler();

export default {
  provide() {
    return {
      [ROUTE_QUERY]: new RouteQuery(this.$router),
    }
  },
  data() {
    return {
      auth: this.$auth, // this makes the auth plugin reactive
      app: this.$app, // this makes the app plugin reactive
      cart: this.$cart, // this makes the cart plugin reactive
      showSearchPopup: false,
      // showNewArtistDeliveryTermsPopup: false,
      // newArtistDeliveryTermsPopupDisplayed: false,
      topBarLift: null,
      termsType: 'buyer',
      showTermsDialog: false,
    }
  },
  name: 'App',
  components: {
    TkToolbar,
    TkView,
    TkDrawer,
    TkFooter,
    LoginDialog,
    TkPageDialog,
    TkConfirm,
    TkToast,
    TkSearchPopup,
    TermsDialog,
    // TkCookieConsent,
    // NewslatterPopup,
    // TkNewArtistDeliveryTermsPopup,
  },

  created() {
    this.fetchUserLocale();

    if (this.$auth.currentUser) {
      this.refreshUser();
    }

    /*
    this.$watch('auth.currentUser', user => {
      // Skip displaying pop-up if user is not artist
      // or the pop-up has been already displayed.
      if (user === null || ! user.isArtist) return;
      if (this.newArtistDeliveryTermsPopupDisplayed) return;

      this.showNewArtistDeliveryTermsPopup = true;
      this.newArtistDeliveryTermsPopupDisplayed = true;
    });
    */

    this.fetchTopBarStaticData();
  },

  methods: {
    setupConfirmDialog() {
      this.$root.$confirm = this.$refs.confirm.open
    },

    async fetchTopBarStaticData() {
      console.log('fetching topBarStaticData')
      // TODO create separate repository class
      let lifts = window.Taiko ? window.Taiko.lifts : []

      // Check if already available from laravel JavaScript
      if (! lifts || lifts.length === 0) {
        const res = await this.$axios.get(`preferences?include=lifts`)
        lifts = res.data['data'].lifts
      }

      console.log('Fetched...', {lifts})

      this.topBarLift = lifts.find((l) => l.component === 'static')
    },

    async refreshUser() {
      await this.$auth.refresh()
      if (
        this.$auth.currentUser &&
        ! this.$auth.currentUser.isLatestTermsAccepted
      ) {
        if (this.$auth.currentUser.isArtist) {
          this.termsType = 'artist'
        }
        this.showTermsDialog = true
      }
    },

    async fetchUserLocale() {
      const localeRes = await localeUtils.getUserLocale()
      this.$app.userCountry = localeRes.toUpperCase()
    },

    onSearchInputMounted() {
      if ((this.$route.name === 'home' || this.$route.name === 'pages') && this.$app.visitsCounter < 3) {
        this.showSearchPopup = true
      }
    },

    async onTermsDialogClose(termId) {
      console.log('onTermsDialogClose', termId)
      this.showTermsDialog = false
      console.log(termId)
      if (! termId) {
        if (this.$route.name !== 'home') {
          this.$router.replace({name: 'home'})
        }
        this.$auth.logout()
      }
    },

  },
}
</script>

<style lang="scss">
</style>
